import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface TermsProps {
	onClose: () => void;
}

const Terms: React.FC<TermsProps> = ({ onClose }) => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: 2,
				width: "100%",
				height: "70vh",
			}}
		>
			<Box
				sx={{
					position: "relative",
					flex: 1,
					width: "100%",
					borderRadius: "8px",
					overflow: "hidden",
				}}
			>
				<Box
					sx={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						height: "40px",
						background: (theme) =>
							`linear-gradient(to bottom, ${theme.palette.background.paper}, transparent)`,
						pointerEvents: "none",
						zIndex: 1, // Ensure it's above the content
					}}
				/>
				<Box
					sx={{
						height: "100%",
						overflowY: "auto",
						width: "100%",
						bgcolor: "background.paper",
						px: 2,
						py: 3, // Add padding to top and bottom
						textAlign: "left",
						"& .MuiTypography-root:not(:last-child)": { mb: 1.5 },
						"& h6": { mt: 2, fontWeight: "bold" },
					}}
				>
					<Typography variant="h5" align="center" gutterBottom>
						Публичная оферта
					</Typography>
					<Typography variant="h6">1. Общие положения</Typography>
					<Typography variant="body2">
						1.0. Сервис AvadaVPN оказывает услуги подключения к
						защищенной сети, для обеспечения безопасности
						передаваемых данных, в том числе по Wi-Fi и сотовым
						сетям в общественных местах.
					</Typography>
					<Typography variant="body2">
						1.1. Исполнитель услуг (самозанятый Чиж Эрик Андреевич),
						далее по тексту – «Исполнитель», публикует настоящую
						публичную оферту о предоставлении доступа к VPN-сервису,
						информация о котором размещена в Телеграм-боте:
						https://t.me/AvadaVPN_bot
					</Typography>
					<Typography variant="body2">
						1.2. Данный документ является публичной офертой, и в
						случае принятия изложенных ниже условий физическое лицо,
						производящее акцепт этой оферты, осуществляет оплату
						Услуги Исполнителя в соответствии с условиями настоящего
						Договора. Оплата Услуги Заказчиком является акцептом
						оферты, что считается равносильным заключению Договора
						возмездного оказания услуг на условиях, изложенных в
						оферте.
					</Typography>
					<Typography variant="body2">
						1.3. На основании вышеизложенного, внимательно
						ознакомьтесь с текстом публичной оферты. Если вы не
						согласны с каким-либо пунктом оферты, вам предлагается
						отказаться от использования Услуг, предоставляемых
						Продавцом.
					</Typography>
					<Typography variant="body2">
						1.4. В настоящей оферте, если контекст не требует иного,
						нижеприведенные термины имеют следующие значения:
					</Typography>
					<Typography variant="body2">
						1.5. «Оферта» – публичное предложение Продавца,
						адресованное любому физическому лицу (гражданину),
						заключить с ним договор возмездного оказания услуг
						(далее – «Договор») на изложенных условиях, включая все
						приложения и ссылки, доступные через официальные каналы
						Продавца.
					</Typography>
					<Typography variant="body2">
						1.6. «Заказчик» – дееспособное физическое лицо,
						заключившее с Исполнителем Договор на условиях настоящей
						оферты.
					</Typography>
					<Typography variant="body2">
						1.7. «Акцепт» – полное и безоговорочное принятие
						Покупателем условий настоящей оферты.
					</Typography>
					<Typography variant="body2">
						1.8. «Услуга» – предоставление Исполнителем Заказчику на
						определенный срок доступа к VPN-сервису, обеспечивающему
						возможность безопасного подключения к управляемым
						Исполнителем серверам. Конфигурационные параметры и
						ключи доступа, предоставляемые Заказчику, являются
						конфиденциальной информацией Заказчика и не подлежат
						передаче третьим лицам. В случае нарушения правил
						использования Исполнитель вправе в одностороннем порядке
						прекратить оказание Услуги без возврата средств.
					</Typography>
					<Typography variant="body2">
						1.9. «Характеристика услуги» — параметры доступа, срок
						действия, количество устройств и иные свойства,
						определяемые Продавцом и размещаемые в официальных
						каналах.
					</Typography>
					<Typography variant="body2">
						1.10. «Заказ» – оформление Покупателем заявки на Услугу
						через Телеграм бот Продавца.
					</Typography>
					<Typography variant="body2">
						1.11. «Активация доступа» – предоставление Заказчику
						конфигурационных данных (или пополнение виртуального
						баланса) для подключения к VPN-сервису посредством
						Телеграм-бота Исполнителя.
					</Typography>
					<Typography variant="body2">
						1.12. «Заказчик» – физическое лицо, активировавшее
						доступ к Услуге посредством Телеграм бота
						https://t.me/AvadaVPN_bot.
					</Typography>
					<Typography variant="h6">2. Предмет договора</Typography>
					<Typography variant="body2">
						2.1. Исполнитель предоставляет Услугу в соответствии с
						актуальными характеристиками и условиями,
						опубликованными в Телеграм-боте Исполнителя, а Заказчик
						производит оплату и принимает Услугу согласно условиям
						настоящей Оферты.
					</Typography>
					<Typography variant="body2">
						2.2. Настоящая Оферта и все сопровождающие её документы
						являются официальными документами Продавца и
						неотъемлемой частью настоящего Договора.
					</Typography>
					<Typography variant="h6">
						3. Оформление и принятие Заказа.
					</Typography>
					<Typography variant="body2">
						3.1. Заказ Услуги осуществляется Покупателем через
						Телеграм бот https://t.me/AvadaVPN_bot.
					</Typography>
					<Typography variant="body2">
						3.2. При оформлении Заказа Заказчик обязуется
						предоставить следующую регистрационную информацию о
						себе: – идентификатор аккаунта Telegram.
					</Typography>
					<Typography variant="body2">
						3.3. Исполнитель не несет ответственности за содержание
						и достоверность информации, предоставленной Покупателем
						при оформлении Заказа.
					</Typography>
					<Typography variant="body2">
						3.4. Заказчик несёт ответственность за достоверность
						предоставленной информации при оформлении Заказа.
					</Typography>
					<Typography variant="body2">
						3.5. Оплата Заказчиком самостоятельно оформленного
						Заказа в Телеграм-боте означает полное и безоговорочное
						согласие Заказчика с условиями настоящей Оферты
						(акцепт). День успешной оплаты Заказа является датой
						заключения Договора между Исполнителем и Заказчиком.
					</Typography>
					<Typography variant="body2">
						3.6. Все информационные материалы, размещённые в
						Телеграм боте Продавца, носят справочный характер и не
						могут в полной мере передавать все технические параметры
						Услуги. В случае возникновения вопросов Заказчик может
						обратиться в поддержку: https://t.me/AvadaVPN_Help.
					</Typography>
					<Typography variant="h6">
						4. Сроки и момент оказания Услуги.
					</Typography>
					<Typography variant="body2">
						4.1. Право на использование Услуги активируется в
						кратчайшие сроки, как правило, в течение 1–5 минут после
						успешной оплаты, путем пополнения виртуального баланса,
						эквивалентного сумме оплаты, в интерфейсе Телеграм-бота
						Исполнителя.
					</Typography>
					<Typography variant="body2">
						4.2. Услуга считается оказанной надлежащим образом и
						принятой Заказчиком с момента активации доступа
						(пополнения виртуального баланса), которая
						подтверждается соответствующим отображением информации в
						интерфейсе Телеграм-бота. Заказчик подтверждает, что
						понимает непрерывный характер Услуги, оказываемой в
						течение оплаченного периода.
					</Typography>
					<Typography variant="body2">
						4.3. В случае предоставления Покупателем недостоверной
						информации при оформлении Заказа, Исполнитель не несёт
						ответственности за неисполнение или ненадлежащее
						исполнение своих обязательств.
					</Typography>
					<Typography variant="h6">5. Оплата Заказа</Typography>
					<Typography variant="body2">
						5.1. Оплата Заказа осуществляется путём перечисления
						Покупателем денежных средств посредством электронного
						перевода через доступные в Телеграм боте способы оплаты.
					</Typography>
					<Typography variant="body2">
						5.2. Подтверждением оплаты является отображение
						соответствующей информации в Личном кабинете Покупателя
						(интерфейсе Телеграм бота).
					</Typography>
					<Typography variant="body2">
						5.3. Денежные средства принимаются следующими способами:
						– оплата банковской картой; – оплата через Систему
						Быстрых Платежей (СБП); – иные способы, указанные в
						Телеграм боте.
					</Typography>
					<Typography variant="body2">
						5.4. Оплата производится единовременно, из расчёта 5
						(пять) рублей в сутки за каждое активное подключённое
						устройство.
					</Typography>
					<Typography variant="body2">
						5.5. Не менее чем за 3 (три) дня до окончания
						оплаченного периода, Покупателю направляется напоминание
						об оплате следующего периода. При отсутствии оплаты
						доступ к Услуге автоматически приостанавливается.
					</Typography>
					<Typography variant="h6">6. Возврат Заказа</Typography>
					<Typography variant="body2">
						6.1. Всем новым Пользователям в рамках программы
						лояльности предоставляется бесплатный тестовый период.
						Осуществление оплаты означает, что Заказчик убедился в
						качестве и функциональности Услуги.
					</Typography>
					<Typography variant="body2">
						6.2. Заказчик не вправе требовать возврата средств за
						оплаченный и начатый период оказания Услуги, за
						исключением случая, предусмотренного в п. 6.4.
					</Typography>
					<Typography variant="body2">
						6.3. Исполнитель не несет ответственности и возврат
						средств не производится в случае сбоев, возникших по
						вине интернет-провайдера Заказчика, технических
						ограничений или нестабильной работы его оборудования или
						программного обеспечения.
					</Typography>
					<Typography variant="body2">
						6.4. Возврат средств возможен только в случае
						документально подтвержденной и постоянной технической
						невозможности предоставления Услуги Исполнителем в
						течение оплаченного периода. Решение о возврате
						принимается Исполнителем индивидуально на основании
						обращения в службу поддержки:
						https://t.me/AvadaVPN_Help.
					</Typography>
					<Typography variant="h6">7. Авторские права</Typography>
					<Typography variant="body2">
						7.1. Телеграм бот, используемый в рамках сервиса
						AvadaVPN, является оригинальной разработкой Продавца и
						охраняется авторским правом. Всё иное программное
						обеспечение, применяемое для обеспечения работы
						VPN-сервиса, основано на открытом исходном коде и
						используется на законных условиях.
					</Typography>
					<Typography variant="body2">
						7.2. Копирование, распространение, модификация, передача
						третьим лицам, размещение на сторонних ресурсах или иное
						использование материалов и элементов сервиса без
						письменного согласия Исполнителя запрещено.
					</Typography>
					<Typography variant="body2">
						7.3. Любое нарушение исключительных прав Исполнителя
						влечет ответственность, предусмотренную действующим
						законодательством Российской Федерации.
					</Typography>
					<Typography variant="h6">
						8. Права, обязанности и ответственность
					</Typography>
					<Typography variant="body2">
						8.1. Исполнитель обязуется предпринимать разумные меры
						для обеспечения бесперебойной работы сервиса, защиты
						данных и соблюдения условий настоящего Договора.
					</Typography>
					<Typography variant="body2">
						8.2. Исполнитель не несет ответственности за
						ненадлежащее использование Услуги Покупателем, а также
						за действия Покупателя, противоречащие законодательству.
					</Typography>
					<Typography variant="body2">
						8.3. Заказчик обязуется использовать Услугу
						исключительно в законных целях и не предпринимать
						действий, способных нарушить стабильность работы сервиса
						или нарушить права третьих лиц.
					</Typography>
					<Typography variant="body2">
						8.4. Исполнитель вправе приостанавливать или прекращать
						оказание Услуги без возврата средств в случае нарушения
						Заказчиком условий настоящей Оферты или
						законодательства.
					</Typography>
					<Typography variant="body2">
						8.5. Исполнитель не несёт ответственности за возможные
						сбои в работе, вызванные техническими ограничениями или
						внешними обстоятельствами, не зависящими от Продавца.
					</Typography>
					<Typography variant="body2">
						8.6. Все обращения и претензии, связанные с работой
						Услуги, направляются Покупателем в поддержку:
						https://t.me/AvadaVPN_Help.
					</Typography>
					<Typography variant="h6">
						9. Программа лояльности
					</Typography>
					<Typography variant="body2">
						9.1. Всем новым Пользователям предоставляется бонус в
						виде виртуального баланса, эквивалентного 15
						(пятнадцати) или 30 (тридцати) рублям, для начала
						использования Услуги.
					</Typography>
					<Typography variant="body2">
						9.2. Заказчик вправе пригласить друзей в сервис,
						используя персональную реферальную ссылку. При активации
						приглашённым Пользователем Услуги, Покупателю
						начисляется бонус в размере, установленном действующими
						условиями программы.
					</Typography>
					<Typography variant="body2">
						9.3. Бонусы, полученные в рамках программы лояльности,
						отображаются в виртуальном балансе и могут быть
						использованы только для оплаты Услуг внутри сервиса
						AvadaVPN. Вывод бонусных средств невозможен.
					</Typography>
					<Typography variant="body2">
						9.4. Попытки злоупотребления программой лояльности
						запрещены. Под злоупотреблением понимаются действия,
						направленные на недобросовестное получение бонусов,
						включая, но не ограничиваясь, создание множественных
						аккаунтов одним лицом. В случае выявления
						злоупотреблений Исполнитель вправе аннулировать все
						бонусы и/или заблокировать доступ к сервису без
						компенсации.
					</Typography>
					<Typography variant="h6">10. Форс-мажор</Typography>
					<Typography variant="body2">
						10.1. Сторона, не исполнившая или ненадлежащим образом
						исполнившая обязательства по настоящему Договору, не
						несет ответственности, если надлежащее исполнение
						оказалось невозможным вследствие обстоятельств
						непреодолимой силы (форс-мажор).
					</Typography>
					<Typography variant="body2">
						10.2. К таким обстоятельствам относятся: стихийные
						бедствия, действия государственных органов, войны,
						массовые беспорядки, перебои в работе
						интернет-провайдеров или оборудования, сбои в работе
						сторонних сервисов и иные обстоятельства, на которые
						стороны не могут повлиять.
					</Typography>
					<Typography variant="body2">
						10.3. При наступлении форс-мажорных обстоятельств срок
						исполнения обязательств по настоящему Договору
						откладывается на время действия таких обстоятельств.
					</Typography>
					<Typography variant="body2">
						10.4. Сторона, для которой наступили форс-мажорные
						обстоятельства, обязуется уведомить другую сторону о
						таких обстоятельствах и их влиянии на исполнение
						обязательств в разумный срок.
					</Typography>
					<Typography variant="h6">
						Заключительные положения
					</Typography>
					<Typography variant="body2">
						Настоящая Оферта вступает в силу с момента её публикации
						и действует бессрочно до момента её отзыва Продавцом.
					</Typography>
					<Typography variant="body2">
						Исполнитель оставляет за собой право вносить изменения в
						Оферту без предварительного уведомления. Актуальная
						версия Оферты всегда доступна в Телеграм боте Продавца :
						https://t.me/AvadaVPN_bot
					</Typography>
					<Typography variant="body2">
						Использование Услуги после внесения изменений в Оферту
						означает согласие Покупателя с такими изменениями.
					</Typography>
					<Typography variant="body2">
						По всем вопросам, связанным с настоящей Офертой и
						предоставляемыми Услугами, Заказчик может обратиться в
						службу поддержки по адресу: https://t.me/AvadaVPN_Help
					</Typography>
					<Typography variant="h5" align="center" sx={{ mt: 4 }}>
						Политика конфиденциальности
					</Typography>
					<Typography variant="body2">
						AvadaVPN строит свою работу на принципах минимального
						сбора данных. Мы не храним и не обрабатываем журналы
						вашей интернет-активности (историю посещений, контент
						передаваемых данных). Для функционирования сервиса,
						технической поддержки и предотвращения злоупотреблений
						мы можем обрабатывать следующие обезличенные данные:
					</Typography>
					<Typography variant="body2">
						- Telegram User ID для идентификации в системе.
					</Typography>
					<Typography variant="body2">
						- Общие технические метаданные подключения (например,
						факт установки соединения, объем переданных данных без
						привязки к содержанию) для обеспечения работоспособности
						и балансировки нагрузки.
					</Typography>
					<Typography variant="body2">
						- Данные, которые вы добровольно предоставляете при
						обращении в поддержку. Мы не сохраняем IP-адреса
						пользователей, являющихся исходными, после завершения
						сессии и не ведем их постоянных журналов.
					</Typography>
					<Typography variant="h6">Хранение и удаление</Typography>
					<Typography variant="body2">
						Данные хранятся только на период, необходимый для
						предоставления Услуг. Заказчик вправе запросить удаление
						информации через поддержку: https://t.me/AvadaVPN_Help
					</Typography>
					<Typography variant="h6">
						Использование cookies и локального хранения данных
					</Typography>
					<Typography variant="body2">
						Для обеспечения функциональности и безопасности нашего
						сервиса мы используем необходимые технологии хранения
						данных на вашем устройстве:
					</Typography>
					<Typography variant="body2">
						- Технические (обязательные) cookie-файлы: Используются
						только для аутентификации пользователей (JWT-токен) и
						поддержания сессии. Без этих файлов использование
						сервиса через веб-интерфейс невозможно.
					</Typography>
					<Typography variant="body2">
						- Локальное хранилище браузера (Local Storage): Может
						применяться для сохранения ваших предпочтительных
						настроек интерфейса (например, темы оформления). Мы не
						используем аналитические или рекламные cookies для
						отслеживания ваших действий.
					</Typography>
					<Typography variant="h6">
						Обработка технических данных подключения
					</Typography>
					<Typography variant="body2">
						Для предоставления, поддержания и защиты услуги VPN наша
						инфраструктура в процессе работы временно обрабатывает
						следующие технические метаданные:
					</Typography>
					<Typography variant="body2">
						- IP-адрес, с которого установлено подключение:
						Требуется для аутентификации запроса, предотвращения
						DDoS-атак и мошенничества. Данные об исходных IP-адресах
						не сохраняются в постоянных журналах и удаляются из
						оперативной памяти после завершения сессии.
					</Typography>
					<Typography variant="body2">
						- Общий объем переданных данных (входной/исходящий
						трафик): Используется для учета использования услуг,
						балансировки нагрузки на серверах и технического
						мониторинга. Эти данные не связаны с вашей
						интернет-активностью (посещаемыми сайтами или
						содержанием передач).
					</Typography>
					<Typography variant="h6">Передача данных</Typography>
					<Typography variant="body2">
						Данные не передаются третьим лицам, за исключением
						случаев, прямо предусмотренных законом.
					</Typography>
					<Typography variant="h6">
						Защита несовершеннолетних
					</Typography>
					<Typography variant="body2">
						Мы не собираем данные несовершеннолетних и просим не
						использовать сервис без согласия родителей или опекунов.
					</Typography>
					<Typography variant="h6">Изменения политики</Typography>
					<Typography variant="body2">
						Мы можем обновлять Политику конфиденциальности. Новая
						версия будет опубликована по адресу:
						https://t.me/AvadaVPN_bot Использование Услуги означает
						согласие пользователя с настоящей политикой.
					</Typography>
					<Typography variant="h6">Контакты</Typography>
					<Typography variant="body2">
						Telegram чат службы поддержки:
						https://t.me/AvadaVPN_Help
					</Typography>
					<Typography variant="h6">Реквизиты</Typography>
					<Typography variant="body2" sx={{ mb: 0 }}>
						ИНН Исполнителя: 645120397750
					</Typography>{" "}
				</Box>{" "}
				<Box
					sx={{
						position: "absolute",
						bottom: 0,
						left: 0,
						right: 0,
						height: "40px",
						background: (theme) =>
							`linear-gradient(to top, ${theme.palette.background.paper}, transparent)`,
						pointerEvents: "none",
					}}
				/>
			</Box>
			<Button onClick={onClose} variant="contained" fullWidth>
				Назад
			</Button>
		</Box>
	);
};

export { Terms };
